import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Sparkline = polyline in SVG user space. Script **normalizes** Y from `min(data)…max(data)` into `pad…h-pad`,
 * maps index `i` to X evenly, then builds `"x,y x,y …"` for the `points` attribute.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'svg-sparkline',
  category: 'motion-svg',
  title: 'SVG sparkline',
  description: 'Tiny script builds polyline points from an array of values.',
  tags: [T.svg, T.chart, T.animation],
  html: `<h2>Sparkline</h2>

<svg id="chart" viewBox="0 0 120 40" width="280" height="96" role="img" aria-label="Trend">
  <!-- points="" filled by script on load -->
  <polyline id="line" fill="none" stroke="var(--nogrok-preview-primary)" stroke-width="2" points=""></polyline>
</svg>
<p class="small">Data: <code id="lbl"></code></p>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 0.5rem;
}

#chart {
  background: var(--nogrok-preview-surface-container);
  border-radius: 8px;
  border: 1px solid var(--nogrok-preview-outline);
}

.small {
  font-size: 0.75rem;
  margin-top: 0.5rem;
  opacity: 0.9;
}

code {
  color: var(--nogrok-preview-accent-warm);
}`,
  js: `const data = [3, 8, 5, 12, 7, 14, 9, 16, 11, 18]
const lbl = document.getElementById('lbl')
if (lbl) lbl.textContent = data.join(', ')

const w = 120
const h = 40
const pad = 4
const min = Math.min(...data)
const max = Math.max(...data)
// Map value v to y in viewBox coords (invert: larger values toward top of chart)
const norm = (v) => pad + (h - 2 * pad) * (1 - (v - min) / (max - min || 1))
const pts = data
  .map((v, i) => {
    const x = pad + ((w - 2 * pad) * i) / (data.length - 1 || 1)
    return x.toFixed(1) + ',' + norm(v).toFixed(1)
  })
  .join(' ')

const line = document.getElementById('line')
if (line instanceof SVGPolylineElement) line.setAttribute('points', pts)`,
}

export default preset
